import { createSlice } from "@reduxjs/toolkit";

const initialState = {

  }

const doctorSlice = createSlice({
    name: 'doctors',
    initialState,
    reducers: {},
})

export const {} = doctorSlice.actions

export default doctorSlice.reducer;